import { render, staticRenderFns } from "./lottery-list.vue?vue&type=template&id=b0bb5e0a&scoped=true"
import script from "./lottery-list.vue?vue&type=script&lang=js"
export * from "./lottery-list.vue?vue&type=script&lang=js"
import style0 from "./lottery-list.vue?vue&type=style&index=0&id=b0bb5e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bb5e0a",
  null
  
)

export default component.exports